<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="'more'"
      [title]="'Custom Fields'"
      [showLinkIcon]="true" />
  }
</ng-template>

<ng-container
  *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (!isRightSideContent && windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text
            [title]="'Custom Fields'" />
          <form [formGroup]="form" novalidate action="#">
            <div class="desktop-header-fields">
              <tidy-select
                class="desktop-header-field"
                [items]="modelTypeFilter"
                [multiple]="false"
                [form]="form.get('selectedModelType')"
                formControlName="selectedModelType"
                (optionChange)="onFilterValueChange()" />
              <tidy-search-input
                formControlName="search"
                [placeholder]="'Search'"
                [icon]="'assets/svg/search.svg'"
                (input)="onSearchChange()" />
            </div>
          </form>
          <tidy-small-button
            [text]="'Add Custom Field'"
            [image]="'assets/svg/add-circle-outline-white.svg'"
            (buttonClick)="addCustomField()" />
        </div>
      </tidy-desktop-header>
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (loaded) {

      <!-- Right-side panel filters -->
      @if (isRightSideContent && isDataLoaded) {
        <form [formGroup]="form" novalidate action="#" style="margin-top: 5rem;">
          <tidy-row class="field-bottom-padding">
            <tidy-select
              [label]="'Model Type'"
              [items]="modelTypeFilter"
              [multiple]="false"
              [form]="form.get('selectedModelType')"
              formControlName="selectedModelType"
              (optionChange)="onFilterValueChange()" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-input
              [icon]="'assets/svg/search.svg'"
              [label]="'Search'"
              formControlName="search"
              [form]="form.controls.search"
              placeholder="Search fields..."
              (input)="onSearchChange()" />
          </tidy-row>
        </form>
      }

      @if (!windowService.isDesktopRes && !isRightSideContent) {
        <div class="custom-desktop-header">
          @if (!isDataLoaded) {
            <div style="width: 100%">
              <ion-skeleton-text
                animated="true"
                style="height: 40px; border-radius: 6px" />
            </div>
          }
          @if (isDataLoaded) {
            <form [formGroup]="form" novalidate action="#" class="form-filters">
              <tidy-select
                class="bills-select-custom-input"
                [label]="'Model Type'"
                [items]="modelTypeFilter"
                [multiple]="false"
                [form]="form.get('selectedModelType')"
                formControlName="selectedModelType"
                (optionChange)="onFilterValueChange()" />
              <tidy-input
                class="bills-select-custom-input"
                [icon]="'assets/svg/search.svg'"
                [label]="'Search'"
                formControlName="search"
                [form]="form.controls.search"
                placeholder="Search fields..."
                (input)="onSearchChange()" />
            </form>
          }
        </div>
      }
      <!-- Skeleton table while loading — rows float in with the entrance cascade;
           the real table below then replaces it in place, instantly (skipEntrance). -->
      @if (!isDataLoaded) {
        <tidy-table
          [skeletonLoading]="true"
          [columnslabels]="headers" />
      }

      @if (isDataLoaded) {
        @if (currentRows?.length > 0) {
          <!-- Add button row above table -->
          <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
            <tidy-text [body]="currentRows.length + (' custom field(s)' | translate)" />
            <tidy-text
              [actionBody]="'+ Add Custom Field'"
              (action)="addCustomField()"
              class="link" />
          </tidy-row>
          <tidy-card class="no-padding">
            <tidy-table
              #tidyTable
              [dataSource]="currentRows"
              [displayedColumns]="headers"
              [columnslabels]="headers"
              [allRowIsClickable]="true"
              [rowsToShow]="25"
              [showColumnLines]="false"
              [showHeader]="true"
              (cellClick)="onTableColumnClick($event)"
              [totalRows]="currentRows.length"
              [skipEntrance]="true"
              [infiniteScroll]="false" />
          </tidy-card>
        }
      }
      @if (isDataLoaded && currentRows?.length === 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No Custom Fields'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'Create your first custom field to get started.'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [actionBody]="'Add Custom Field'"
              (action)="addCustomField()"
              class="link" />
          </tidy-row>
        </tidy-alert>
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
              [templateContent]="content"
              [isfullWidthContent]="true" />
